import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { showToast as toast } from '../toastManager';
import axios from 'axios';
import { Button, Spinner, Container, Row, Col } from 'react-bootstrap';
import { reset as resetAnalytics } from '../utils/analytics';

function SignOut({ ViewedPage, shop_domain, app_url, isInSettingsContainer = false }) {
    const navigate = useNavigate();
    if (!isInSettingsContainer) {
        navigate('/settings', { state: { default_tab: 'sign-out' } });
    }
    
    const [loading, setLoading] = useState(false);
    
    const handleSignOut = () => {
        setLoading(true);
        try {
            axios.post(`${app_url}/api/signout`, { shop_domain: shop_domain })
                .then(response => {
                    Cookies.remove('shop', {
                        secure: process.env.REACT_APP_WENV !== "local",
                        domain: process.env.REACT_APP_WENV !== "local" ? ".cognitiveux.ai" : "",
                        path: "/",
                    });
                    Cookies.remove('shop_name', {
                        secure: process.env.REACT_APP_WENV !== "local",
                        domain: process.env.REACT_APP_WENV !== "local" ? ".cognitiveux.ai" : "",
                        path: "/",
                    });
                    Cookies.remove('stores', {
                        secure: process.env.REACT_APP_WENV !== "local",
                        domain: process.env.REACT_APP_WENV !== "local" ? ".cognitiveux.ai" : "",
                        path: "/",
                    });
                    Cookies.remove('allowed_pages_json', {
                        secure: process.env.REACT_APP_WENV !== "local",
                        domain: process.env.REACT_APP_WENV !== "local" ? ".cognitiveux.ai" : "",
                        path: "/",
                    });
                    Cookies.remove('user_email', {
                        secure: process.env.REACT_APP_WENV !== "local",
                        domain: process.env.REACT_APP_WENV !== "local" ? ".cognitiveux.ai" : "",
                        path: "/",
                    });
                    Cookies.remove('user_role', {
                        secure: process.env.REACT_APP_WENV !== "local",
                        domain: process.env.REACT_APP_WENV !== "local" ? ".cognitiveux.ai" : "",
                        path: "/",
                    });
                    Cookies.remove('user_permissions',{
                        secure: process.env.REACT_APP_WENV !== "local",
                        domain: process.env.REACT_APP_WENV !== "local" ? ".cognitiveux.ai" : "",
                        path: "/",
                    });
                    // Detach the analytics identity with the session.
                    resetAnalytics();
                    window.location.href = '/';
                })
                .catch(error => {
                    setLoading(false);
                    toast.error("Sign-out failed");
                });
        } catch (error) {
            setLoading(false);
            toast.error("Sign-out failed");
        }
    };

    return (
        <div style={{ position: "relative" }}>
            {!shop_domain ?
                <div className='go_to_shopify_admin_div'>
                    <h5 style={{ display: 'inline-block' }}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
                :
                <>
                    {loading ?
                        <div className='main_conatiner_spinner'>
                            <Spinner animation="border" />
                        </div>
                        :
                        <>
                            {!isInSettingsContainer && (
                                <div className='main-title mt-4'>
                                    <h2>Sign-Out</h2>
                                </div>
                            )}
                            <Container fluid className="mt-4">
                                <Row className="">
                                    <Col md={8} lg={6} style={{ padding: "0 !important"}}>
                                        <div className="p-4 rounded bg-white shadow-sm">
                                            <h5 className="mb-4">Are you sure you want to sign out?</h5>
                                            <p className="text-muted mb-4" style={{ fontSize: 'small' }}>
                                                You will be redirected to the login page after signing out.
                                            </p>
                                            <Button 
                                                size="sm"
                                                onClick={handleSignOut}
                                                className="px-4"
                                                style={{ backgroundColor: 'var(--cux-btn, rgb(19, 40, 72))', color:"white", border: 'none' }}
                                            >
                                                Sign Out
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </>
                    }
                </>
            }
        </div>
    );
}

export default SignOut;